import { render, staticRenderFns } from "./AddFree.vue?vue&type=template&id=51b0e429&scoped=true"
import script from "./AddFree.vue?vue&type=script&lang=js"
export * from "./AddFree.vue?vue&type=script&lang=js"
import style0 from "./AddFree.vue?vue&type=style&index=0&id=51b0e429&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b0e429",
  null
  
)

export default component.exports